export default "__VITE_ASSET__716571d7__"